import { forwardRef, useState } from "react";
import {
  Alert,
  AppBar,
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Slide,
  Tab,
  Tabs,
  Toolbar,
  Tooltip,
  Typography
} from "@mui/material";
import { useContext } from "react";
import { QuotaTable } from "./QuotaTable";
import { AreaContext } from "../context/AreaContext";
import { StoragePackList } from "./StoragePackList";
import { TotalStorageAllocation } from "./TotalStorageAllocation";
import { UnclaimedResources } from "./UnclaimedResources";
import { Close } from "@mui/icons-material";
import { BaseAllocation } from "./BaseAllocation";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

export const Area = () => {
  const { area, setArea, retryArea } = useContext(AreaContext);
  const [tab, setTab] = useState(0);

if (area.error) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        gap: 2,
      }}
    >
      <Alert severity="error" sx={{ maxWidth: 480 }}>{area.error}</Alert>
      <Button
        variant="contained"
        sx={{ backgroundColor: "#A60F2D" }}
        onClick={retryArea}
      >
        Retry
      </Button>
    </Box>
  );
}

if (!area.initialized) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%", // or "100vh" if full page
        gap: 2,
      }}
    >
      <CircularProgress
        size={100}
        thickness={2}
        sx={{ color: "#A60F2D" }}
      />
      {area.loadAttempt > 1 && (
        <Typography variant="body2" sx={{ color: "text.secondary", textAlign: "center", maxWidth: 360 }}>
          Still connecting — this can take up to a minute after a period of inactivity.
          {" "}(Attempt {area.loadAttempt} of {area.loadMaxAttempts})
        </Typography>
      )}
    </Box>
  );
}

const renderUnclaimedResources = () => {
  return(
    <Dialog
          fullScreen={true}
          open={area.unclaimedResourcesVisible}
          TransitionComponent={Transition}
        >
    <DialogContent>
            <AppBar sx={{ position: 'relative', backgroundColor: "#A60F2D", color: "white"}}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => setArea((prev) => ({...prev, unclaimedResourcesVisible: !prev.unclaimedResourcesVisible}))}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              {"Unclaimed Resources"}
            </Typography>           
          </Toolbar>
        </AppBar>
      <UnclaimedResources areaId={area.id} />
    </DialogContent></Dialog>
  )
}

  return (
    <Box>
      {renderUnclaimedResources()}
      <TotalStorageAllocation />
      <Toolbar
      variant="dense"
        disableGutters={true}
          sx={{
            ml: "auto",
    maxHeight: 25,
    borderRadius: 9999,          
    backgroundColor: "#A60F2D", 
    px: 0,
    minHeight: "auto",
    height: "auto",
    color: "white",
    width: "fit-content", 
  }}
      >
                <Tooltip 
                  title="Add a resource to your area"
                  placement="bottom"
                  >
        <Button sx={{
          color: "white",
          px: 2,
          py: 0,
          minHeight: "auto"
        }}onClick={() => setArea((prev) => ({...prev, unclaimedResourcesVisible: !prev.unclaimedResourcesVisible}))}>
          Add Resource
        </Button>
        </Tooltip>
      </Toolbar>
      <br />
      <Tabs value={tab} onChange={(_, v) => setTab(v)} variant="fullWidth"
          sx={{
    "& .MuiTab-root": {
      backgroundColor: "white",
      color: "black",
    },
    "& .MuiTab-root.Mui-selected": {
      backgroundColor: "#A60F2D",
      color: "white",
    },
    "& .MuiTabs-indicator": {
      display: "none",
    },
  }}
        >
        <Tab label="Base Allocation" />
        <Tab label="Storage Packs" />
        <Tab label="Email" />
        <Tab label="OneDrive" />
        <Tab label="Teams / SharePoint" />
      </Tabs>

      {tab === 0 && <BaseAllocation />}
      {tab === 1 && <StoragePackList />}
      {tab === 2 && <QuotaTable areaId={area.id} resourceType={"Mailbox"} /> }
      {tab === 3 && <QuotaTable areaId={area.id} resourceType={"OneDrive"} />}
      {tab === 4 && <QuotaTable areaId={area.id} resourceType={"Teams/SharePoint"} />}
    </Box>
  );
};
